import { Key } from "react";
import { Column as RdgColumn, SelectColumn } from "react-data-grid";

import { ResultData } from "../../../../../service/Shared";
import { Checkbox } from "../../../../forms";

interface CustomSelectColumnProps {
  selectableUuids: Set<Key>;
  allVisibleAllowedSelected: boolean;
  selectedRows: ReadonlySet<Key>;
  setSelectedRows: (rows: ReadonlySet<Key>) => void;
  rowKeyGetter: (row: ResultData) => Key;
}

export const CustomSelectColumn = ({
  selectableUuids,
  allVisibleAllowedSelected,
  selectedRows,
  setSelectedRows,
  rowKeyGetter,
}: CustomSelectColumnProps): RdgColumn<ResultData> => {
  return {
    ...SelectColumn,
    key: "select",
    name: "",
    width: 42,

    // Header "Select All" using your Checkbox
    headerRenderer: () => {
      return (
        <div className="DataGridCheckboxCell">
          <Checkbox
            checked={allVisibleAllowedSelected}
            onChange={(e) => {
              const nextChecked = e.target.checked;
              // Select all currently selectable UUIDs or clear all
              setSelectedRows(nextChecked ? new Set(selectableUuids) : new Set<Key>());
            }}
          />
        </div>
      );
    },

    // Row checkbox using your Checkbox
    formatter: ({ row }) => {
      const id = rowKeyGetter(row) as Key;
      const isChecked = selectedRows.has(id);

      return (
        <div className="DataGridCheckboxCell">
          <Checkbox
            checked={isChecked}
            onChange={(e) => {
              const nextChecked = e.target.checked;
              // Toggle membership in selection set
              const nextSet = new Set<Key>(selectedRows);
              if (nextChecked) nextSet.add(id);
              else nextSet.delete(id);
              setSelectedRows(nextSet);
            }}
          />
        </div>
      );
    },
  };
};
